import {
    GET_MASTER_COURSES_BY_COUNTRY_REQUEST,
    GET_MASTER_COURSES_BY_COUNTRY_SUCCESS,
    GET_MASTER_COURSES_BY_COUNTRY_FAILURE,
    RELOAD_MASTER_COURSES,
    GET_COUNTRIES_WITH_MASTER_COURSES_REQUEST,
    GET_COUNTRIES_WITH_MASTER_COURSES_SUCCESS,
    GET_COUNTRIES_WITH_MASTER_COURSES_FAILURE,
    CHANGE_MASTER_COURSE_COUNTRY,
    CHANGE_MASTER_COURSE_CURRICULUM_TYPE,
    GET_SUBJECTS_REQUEST,
    GET_SUBJECTS_SUCCESS,
    GET_SUBJECTS_FAILURE,
    CHANGE_SUBJECT,
    GET_MASTER_COURSES_SUCCESS
} from './actions';

const initState = {
    countries: [],
    courses: [],
    countryLoaded: false,
    selectedCountry: '',
    currentView: 'courseList',
    curriculumType: '',
    subjects: [],
    subjectLoaded: false,
    selectedSubject: ''
};

export default function (state = initState, action) {
    switch (action.type) {
    case CHANGE_MASTER_COURSE_COUNTRY: {
        return {
            ...state,
            selectedCountry: action.countryCode
        };
    }
    case GET_MASTER_COURSES_BY_COUNTRY_REQUEST: {
        return { ...state };
    }
    case GET_MASTER_COURSES_BY_COUNTRY_SUCCESS: {
        return {
            ...state,
            courses: action.data
        };
    }
    case GET_MASTER_COURSES_BY_COUNTRY_FAILURE: {
        return {
            ...state
        };
    }
    case GET_COUNTRIES_WITH_MASTER_COURSES_REQUEST: {
        return { ...state };
    }
    case GET_COUNTRIES_WITH_MASTER_COURSES_SUCCESS: {
        return {
            ...state,
            countries: action.data,
            countryLoaded: true
        };
    }
    case GET_COUNTRIES_WITH_MASTER_COURSES_FAILURE: {
        return {
            ...state,
            countryLoaded: false
        };
    }
    case RELOAD_MASTER_COURSES: {
        return {
            ...state,
            countryLoaded: false
        };
    }

    // Products
    case GET_SUBJECTS_REQUEST: {
        return { ...state };
    }
    case GET_SUBJECTS_SUCCESS: {
        return {
            ...state,
            subjects: action.data,
            subjectLoaded: true
        };
    }
    case GET_SUBJECTS_FAILURE: {
        return {
            ...state,
            subjectLoaded: false
        };
    }
    case CHANGE_SUBJECT: {
        return {
            ...state,
            selectedSubject: action.subject
        };
    }
    case CHANGE_MASTER_COURSE_CURRICULUM_TYPE: {
        return {
            ...state,
            curriculumType: action.curriculumCode,
            selectedCountry: '',
            courses: [],
            selectedSubject: ''
        };
    }
    case GET_MASTER_COURSES_SUCCESS: {
        return {
            ...state,
            courses: action.data
        };
    }

    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/master-courses/reducer.js